import { useState } from 'react';
import type { IteroOrder } from '../../../../../services/iteroBrowse';
import { useOrderAssetDownloads } from '../order-view/useOrderAssetDownloads';
import { Scan3dCard } from './Scan3dCard';
import { ScanFilesCard } from './ScanFilesCard';
import { ScanImagesSection } from './ScanImagesSection';
import { ScanViewerOverlay } from './ScanViewerOverlay';
import type { ScanImageSets } from './useScanImageSets';

interface ScansTabProps {
    order: IteroOrder;
    images: ScanImageSets;
}

export function ScansTab({ order, images }: ScansTabProps) {
    const [viewerOpen, setViewerOpen] = useState(false);
    const downloads = useOrderAssetDownloads(order.rxId, order.orderCode);

    return (
        <div className="flex flex-col gap-3 px-5 pb-6 pt-4">
            <ScanImagesSection sets={images} />
            <Scan3dCard onOpen={() => setViewerOpen(true)} />
            <ScanFilesCard
                downloads={downloads}
                tallies={{
                    IMAGE_GALLERY: images['model-views'].tally,
                    SCREEN_CAPTURE: images['screen-captures'].tally
                }}
            />
            {viewerOpen && (
                <ScanViewerOverlay
                    rxId={order.rxId}
                    orderCode={order.orderCode}
                    viewerUrl={order.viewerUrl}
                    onClose={() => setViewerOpen(false)}
                />
            )}
        </div>
    );
}
